<template>
  <div v-loading.body="loading">
    <el-row>
      <el-col style="border: 1px solid #ddd;">
        <div
          style="background: #f3f3f3;height: 50px;line-height:30px;padding: 0 25px;display: flex; align-items:center;"
        >
          <div>SQL警报配置</div>
          <el-button
            style="margin-left: auto;background: #409EFF"
            type="success"
            size="mini"
            @click="addDialog()"
            >添加</el-button
          >
        </div>
        <div style="margin-bottom: 0;">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              width="80"
              prop="id"
              label="ID"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              width="300"
              prop="title"
              label="描述"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="type_txt"
              label="类型"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sql"
              label="SQL/方法"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              width="100"
              prop="is_use_txt"
              label="是否启动"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              width="100"
              prop="frequency_txt"
              label="频率"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              width="100"
              prop="start_time"
              label="开始执行时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              width="100"
              prop="end_time"
              label="结束执行时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="150"
              >>
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="editDialog(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="del(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="保存SQL" :visible.sync="dialogFormVisible" width="35%">
      <el-form :model="form">
        <el-form-item label="描述" required>
          <el-input
            v-model="form.title"
            placeholder="描述"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type" required>
          <el-select v-model="form.type" filterable placeholder="类型">
            <el-option
                v-for="item in types"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="SQL/方法内容" required>
          <el-input
            v-model="form.sql"
            type="textarea"
            placeholder="输入完整SQL语句,只能输入select语句/在MonitorService存在的静态方法"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="执行频率" prop="is_use" required>
          <el-select v-model="form.frequency" filterable placeholder="执行频率">
            <el-option
              v-for="item in frequency"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="is_use" required>
          <el-select v-model="form.is_use" filterable placeholder="是否启用">
            <el-option
              v-for="item in is_use"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起止时间" required>
          <el-date-picker
            v-model="form.start_end_time"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData(true);
    });
  },
  data() {
    return {
      loading: false,
      tableLoading: false,
      dialogFormVisible: false,
      resData: {},
      form: {
        title: "",
        sql: "",
        is_use: "",
        frequency: "1",
        type: "1",
        id: 0
      },
      is_use: [
        {
          value: "1",
          label: "启用"
        },
        {
          value: "0",
          label: "禁用"
        }
      ],
      types: [
        {
          value: "1",
          label: "SQL"
        },
        {
          value: "2",
          label: "方法"
        }
      ],
      frequency: [
        {
          value: "1",
          label: "1分钟"
        },
        {
          value: "2",
          label: "10分钟"
        },
        {
          value: "3",
          label: "30分钟"
        },
        {
          value: "4",
          label: "1个小时"
        }
      ],
      url: "/erp/Setting/listSqlNotice"
    };
  },
  methods: {
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleEdit() {
      let url = "/erp/Setting/saveSqlNotice";
      let data = {
        id: this.form.id || 0,
        title: this.form.title || "",
        sql: this.form.sql || "",
        is_use: this.form.is_use,
        type: this.form.type,
        frequency: this.form.frequency,
        start_end_time: this.form.start_end_time
      };
      this.$http.post(url, data).then(res => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: res.data.msg
          });
          this.setdefault();
          this.fetchData(true);
        }
      });
    },
    addDialog() {
      this.setdefault();
      this.dialogFormVisible = true;
    },
    editDialog(index, row) {
      this.form.id = row.id;
      this.form.title = row.title;
      this.form.sql = row.sql;
      this.form.is_use = row.is_use;
      this.form.type = row.type;
      this.form.frequency = row.frequency;
      this.form.start_end_time = [row.start_time, row.end_time];

      this.dialogFormVisible = true;
    },
    setdefault() {
      this.form.id = "0";
      this.form.title = "";
      this.form.sql = "";
      this.form.is_use = "1";
      this.form.type = "1";
      this.form.frequency = "1";
    },
    del(index, row) {
      let url = "/erp/Setting/delSqlNotice";
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http.post(url, { id: row.id }).then(res => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message({
              type: "success",
              message: res.data.msg
            });

            this.fetchData(true);
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/SqlNoticeSetting.vue